// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a1189817","488":"ae754a7b"}[chunkId] + ".chunk.js";
};